<template>
    <v-layout>
        <v-flex xs12>
            <v-card class="mx-auto" flat>
                <confirmation-header-text text="NRN visa details" class="ml-0"
                                          icon="mdi-human-greeting"></confirmation-header-text>
                <v-card-text class="pt-3 pb-0">
                    <v-layout row>
                        <v-flex xs12 sm6>
                            <address-auto-complete
                                    :label="'Full address of '+ extendConvertVisaDetails.country_name"
                                    :rules="[rules.required]"
                                    v-model="visa.extra.application_data.full_address"
                                    :country-code="extendConvertVisaDetails.country_code"
                            >
                            </address-auto-complete>
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-2">
                            <address-auto-complete
                                    label="Full address of Nepal"
                                    :rules="[rules.required]"
                                    v-model="visa.extra.application_data.full_address_nepal"
                                    :country-code="extendConvertVisaDetails.country_code"
                            >
                            </address-auto-complete>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    outlined
                                    v-model="visa.extra.application_data.nrn_card_number"
                                    label="NRN card number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-5">
                            <new-date-picker
                                    v-model="visa.extra.application_data.nrn_card_expiry_date"
                                    label="NRN card expiry date"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import NewDatePicker from "../../DatePickerNew";

    export default {
        name: 'NRNVisa',
        data: () => ({
            rules: {
                required: value => !!value || "Required."
            },
        }),
        components: {
            NewDatePicker,
            "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
        },
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            extendConvertVisaDetails() {
                return this.$store.state.VisaSingle.extendConvertVisaDetail;
            }
        },
    }
    ;
</script>

<style>
</style>
